<template>
  <v-container fluid>
    <v-row align="center"
      justify="center"
      class="my-10">
      <h1>異常單據查詢</h1>
    </v-row>
    <v-card>
      <v-data-table
        :headers="tableHeaders"
        :items="tableItems"
        :loading="isTableLoading"
        :options="tableOptions"
        :search="tableSearch"
        :items-per-page="-1"
        item-key="id"
        show-expand
        multi-sort
        @item-expanded="onTableItemExpanded"
      >
        <template v-slot:top>
          <v-container>
            <v-row>
              <v-col>
                <v-menu
                ref="datePickerMenu"
                :close-on-content-click="false"
                :return-value.sync="selectedDate"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="selectedDate"
                    label="日期"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedDate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="onDatePickerMenuInput"
                  >
                    確認
                  </v-btn>
                </v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <v-checkbox
                  :label="autoUpdateCheckboxLabel"
                  @change="onAutoUpdateCheckboxChange"
                ></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox
                  label="只顯示未確認"
                  @change="onFilterCheckboxChange"
                ></v-checkbox>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </v-container>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            class="mr-2"
            @click="confirmMessage(item)"
          >
            mdi-archive-arrow-down-outline
          </v-icon>
          <v-icon
            class="mr-2"
            @click="jumpToParkingSpace(item)"
          >
            mdi-open-in-new
          </v-icon>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-timeline class="my-5">
                <v-timeline-item
                  v-for="(record, i) in item.records"
                  :key="i"
                >
                  <template v-slot:opposite>
                    <span
                      :class="`headline font-weight-bold`"
                      v-text="record.time"
                    ></span>
                  </template>
                  <div>
                    <h3>{{record.carId}}</h3>
                    <img :src="record.image" width="500">
                  </div>
                </v-timeline-item>
                <v-timeline-item color="red lighten-1" v-if="item.isDeleted">
                  <template v-slot:opposite>
                    <span
                      :class="`headline font-weight-bold`"
                      v-text="'已刪單'"
                    ></span>
                  </template>
                </v-timeline-item>
              </v-timeline>
            </td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
export default{
  data() {
    return {
      autoUpdateCheckboxLabel: '自動更新',
      selectedDate: null,
      watcher: null,
      watcherCount: 30,
      tableSoryBy: [{ key: 'time', order: 'desc'}],
      tableHeaders: [
        {
          text: '時間',
          value: 'time',
          width: '20%',
          sortable: true,
        },
        {
          text: '種類',
          value: 'typeDescribe',
          width: '10%',
          sortable: true,
        },
        {
          text: '單號',
          value: 'govTicketId',
          width: '20%',
          sortable: false,
        },
        {
          text: '車格',
          value: 'parkingSpace',
          width: '10%',
          sortable: false,
        },
        {
          text: '車牌',
          value: 'licensePlate',
          width: '10%',
          sortable: false,
        },
        {
          text: '狀態',
          value: 'isConfirmed',
          width: '15%',
          sortable: false,
        },
        {
          text: '操作',
          value: 'actions',
          width: '10%',
          sortable: false,
        },
        {
          text: '',
          value: 'data-table-expand',
          width: '5%'
        },
      ],
      tableItems: [],
      tableOptions: {
        sortBy: ['time'],
        sortDesc: [true],
      },
      tableSearch: '',
      isAlreadyQueried: false,
      isTableLoading: false,
      eventDescribes: {
        'abcar': 'AB車',
        're-in': '重複入車'
      }
    };
  },
  unmounted() {
    clearInterval(this.watcher);
  },
  methods: {
    async onTableItemExpanded(event) {
      if (event.value)  {
        const item = event.item;

        if (item.type === 'abcar') {
          await this.getABCarDetail(item);

          return;
        }

        if (item.type === 're-in') {
          await this.getReInDetail(item);
          return;
        }
      }
    },
    async onDatePickerMenuInput() {
      this.$refs.datePickerMenu.save(this.selectedDate);
      try {
        this.isTableLoading = true;
        this.tableItems = [];
        this.isAlreadyQueried = false;
        
        const resp = await this.axios.get(`api/messages?date=${this.selectedDate}`);
        resp.data.forEach((message) => {
          this.setTableItem(message);
        });

        this.isAlreadyQueried = true;
      } catch(err) {
        alert(err);
      } finally {
        this.isTableLoading = false;
      }
    },
    onAutoUpdateCheckboxChange(isChecked) {
      if (!isChecked) {
        this.isTableLoading = false;
        clearInterval(this.watcher);

        return;
      }
      this.isTableLoading = true;
      this.watcher = setInterval(this.getMessageJob, 1000);
    },
    onFilterCheckboxChange(isChecked) {
      if (!isChecked) {
        this.tableSearch = '';
      } else {
        this.tableSearch = '未確認';
      }
    },
    async getMessageJob() {
      if (this.watcherCount > 0) {
        this.autoUpdateCheckboxLabel = `自動更新 (${this.watcherCount.toString().padStart(3, ' ')}s)`
        this.watcherCount -= 1;
        return;
      }

      if (!this.selectedDate) {
        return;
      }

      if (!this.isAlreadyQueried) {
        return;
      }

      try {
        this.isTableLoading = false;
        let lastId = 0;

        if (this.tableItems.length > 0) {
          lastId = this.tableItems.at(-1).id;
        }

        const resp = await this.axios.get(`api/messages?date=${this.selectedDate}&lastId=${lastId}`);
        const data = resp.data;

        if (data.length > 0) {
          resp.data.forEach((message) => {
            this.setTableItem(message);
          })

          const permission = await Notification.requestPermission();

          if (permission === 'granted') {
            new Notification('異常單據通知', {
              body: `有 ${data.length} 張新單據出現異常(AB車), 請盡速檢查!`,
              renotify: true,
              tag: 'message',
            })
          }
        }
      } catch(err) {
        alert(err);
      } finally {
        this.watcherCount = 30;
        this.isTableLoading = true;
      }
    },
    async confirmMessage(item) {
      try {
        await this.axios.post(`api/messages/${item.id}/confirm`);

        item.isConfirmed = '已確認';
      } catch (err) {
        alert(err);
      }
    },
    jumpToParkingSpace(item) {
      this.$store.commit("SetPS", { id: item.parkingSpace, code: item.parkingSpace });
      let routeData = this.$router.resolve({ name: 'ps', query: { id: item.parkingSpace, code: item.parkingSpace } });
      window.open(routeData.href, '_blank');
    },
    setTableItem(message) {
      this.tableItems.push({
        id: message.id,
        time: this.$moment(message.time).format('YYYY-MM-DD HH:mm:ss'),
        type: message.type,
        typeDescribe: this.eventDescribes[message.type],
        govTicketId: message.gov_ticket_id,
        parkingSpace: message.parking_space,
        licensePlate: message.license_plate || '無車牌',
        isConfirmed: message.is_confirmed? `已確認 by ${message.operator}` : '未確認',
        records: [],
        isDeleted: false,
      });
    },
    async getABCarDetail(item) {
      try {
          item.records = [];

          const resp = await this.axios.get(`api/tickets/${item.govTicketId}/records`);
          const data = resp.data;

          item.isDeleted = data.isDeleted;
        
          if (data.records && data.records.length > 0) {
            data.records.forEach((record) => {
              item.records.push({
                carId: record.car_id|| '無車牌',
                time: record.record_time,
                image: record.record_image.replace('/public', ''),
              })
            });
          }
        } catch (err) {
          alert(err);
        }
    },
    async getReInDetail(item) {
      try {
        item.records = [];

        const resp = await this.axios.get(`api/parking_spaces/${item.parkingSpace}/re-in?recordTime=${item.time}`);
        const records = resp.data;

        if (records.length > 0) {
          records.forEach((record) => {
            item.records.push({
              carId: record.car_id,
              time: record.record_time,
              image: record.record_image.replace('/public', ''),
            })
          })
        }
      } catch (err) {
        alert(err);
      }
    },
  },
};
</script>
